import React from 'react';

import './ImportantPoints.scss';
import imageLifebuoy from '../../../styles/assets/icons/lifebuoy-white.svg';
import imageEye from '../../../styles/assets/icons/explore.svg';
import imageJoin from '../../../styles/assets/icons/join.svg';

import { ImageTextGroup } from './ImageTextGroup/ImageTextGroup';

export function ImportantPoints() {
  
  return (
    <div className='ImportantPoints'>

        <div className='ImportantPoints__item'>
          <ImageTextGroup
            image={ imageJoin }
            text={(
              <>
                <p>Everything you post you won't be able to edit or delete.</p>
                <p>So, <u>pay attention</u> and <u>be brave</u></p>
              </>
            )}
          />
        </div>
        
        <div className='ImportantPoints__item'>
          <ImageTextGroup
            image={ imageLifebuoy }
            isBackgroundInversed={ true }
            text={(
              <>
                <p>
                  After you hit "<u>Post</u>" button you still have some time to <u>cancel</u> the posting process.
                </p>
              </>
            )}
          />
        </div>

        <div className='ImportantPoints__item'>
          <ImageTextGroup
            image={ imageEye }
            text={(
              <>
                <p>Post details is a <u>public</u> page. <u>Anyone</u> including unregistered users <u>can view</u> it.</p>
              </>
            )}
          />
        </div>
    </div>
  );
}
